import { render, staticRenderFns } from "./subsidy.vue?vue&type=template&id=043c2dac&"
import script from "./subsidy.vue?vue&type=script&lang=js&"
export * from "./subsidy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports